const APPLICATION_DELETE = [
    {
        sectionID: 'applicationDelete',
        sectionName: '',
        fieldList: [
            {
                id: 'delete',
                label: 'Please confirm if you would like to delete the Draft Application?',
                type: 'label'
            }
        ]
    }
];

export default APPLICATION_DELETE;
